const mutations = {

}
export default mutations;


// WEBPACK FOOTER //
// ./src/store/modules/project/mutations/index.js